module.exports = __webpack_public_path__ + "assets/img/9_38_big.16f08753.jpg";